import React from "react";
import { Box, Button, Column, Columns, Title } from "@allxsmith/bestax-bulma";
import useInput from "../../../hooks/useInput";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../../actions/dataActions";

export function NewVehicleTrackerType({dataFresh}){
    const dispatch = useDispatch();
    const [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name"
    });
    const [cost, costInput, setCost] = useInput({
        type: "number",
        currency: true,
        label: "Monthly Cost"
    });
    const [upFrontCost, upFrontCostInput, setUpFrontCost] = useInput({
        type: "number",
        currency: true,
        label: "UpFront Cost"
    });

    const clear = () =>{
        setCost(0);
        setName("");
        setUpFrontCost(0);
    }

    const onAdd = () => {
        const conf = {
            data: {name:name, cost:cost, upfront_cost:upFrontCost},
            method: "post",
            url: "api/vehicletrackertype"
        }
        axios(conf).then((res)=> {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            clear()
        }).catch(err => {
            if(err){
                toast.error("There was an error", {position: "top-right"});
            }
        })
    }

    return (
        <Box className="settings_type">
            <details>
                <summary><Title>New Vehicle Tracker Type</Title></summary>
            <Columns isMultiline>
                {nameInput}
                {costInput}
                {upFrontCostInput}
            </Columns>
            <Columns isMultiline>
                <Column>
                    <Button
                        color={"success"}
                        onClick={() => onAdd()}
                        isFullWidth
                    >
                        Add +
                    </Button>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}